function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 20,
  height: 18,
  x: 0,
  y: 0,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAMAAABsDg4iAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAe1BMVEUXo0UXo0UXo0UXo0UX o0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UX o0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0UXo0X///9M7Go4 AAAAJ3RSTlMAT+DyUff4/JsvMGVomXQqLXKEQkWCg0FEgXAkJ27MlLCxy/lQ4VLDq9PaAAAAAWJL R0QovbC1sgAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+QGCgs0GAXvYrAAAABvSURBVBjT vdDJFkNAFIThS6NpQxKJeciA1Pu/IWqpj61afeff3SuOqw5zPfFhLRBtRy3KjuoshpExJoqBhEgZ M9l3A+7EgzGnn8CLKK6NJV0BNdEwtnQH9MSwRY3xve8DfInf9pDAvn2SeTk+efmvRqwbIf0ikM4A AAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDYtMTBUMTE6NTI6MjQrMDM6MDCHAm6uAAAAJXRFWHRk YXRlOm1vZGlmeQAyMDIwLTA2LTEwVDExOjUyOjI0KzAzOjAw9l/WEgAAAABJRU5ErkJggg=="
});

var SvgCompare = function SvgCompare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    enableBackground: "new 0 0 20 18",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compare.539b999b.svg";
export { ForwardRef as ReactComponent };